import {
  GETWALLETOWNERBANKDETAILSLIST_SUCCESS,
  GETWALLETOWNERBANKDETAILSLIST_FAILED,
  RESET_GETWALLETOWNERBANKDETAILSLIST,
  LOADING_GETWALLETOWNERBANKDETAILSLIST,
  NETWORK_ERROR_GETWALLETOWNERBANKDETAILSLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETWALLETOWNERBANKDETAILSLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETWALLETOWNERBANKDETAILSLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETWALLETOWNERBANKDETAILSLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETWALLETOWNERBANKDETAILSLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETWALLETOWNERBANKDETAILSLIST:
      return (state = initialState);
    default:
      return state;
  }
};
